<template>
  <div>
    <b-row class="m-0">
        <b-col class="p-0">
        <fieldset class="border p-3">
            <legend  class="w-auto bg-facebook px-2 py-1 text-white rounded border h6">SOCIAL MEDIA  <font-awesome-icon icon="plus-circle" class="ml-3 cursor-pointer" @click="modal=true" /></legend>
                <table class="table table-bordered mt-2 mb-0 table-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col">Social Media</th>
                            <th scope="col">Profile Name</th>
                            <th scope="col" class="text-center">Profile Link</th>
                            <th scope="col" class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody class="bg-white text-dark">
                        <tr v-for="(manpower_social_media, index) in params.form.manpower_social_media">
                            <td>
                                {{manpower_social_media.social_media_type.description}}
                            </td>
                            <td>
                                {{manpower_social_media.profile_name}}
                            </td>
                            <td>
                                <a :href="manpower_social_media.profile_link">
                                    <b-badge variant="info">
                                        {{manpower_social_media.profile_link}}
                                    </b-badge>
                                </a>
                            </td>
                            <td class="text-center">
                                <b-button size="sm" variant="danger" @click="deleteSocialMedia(manpower_social_media.id)"><font-awesome-icon icon="minus-circle" /> Remove</b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>
        </b-col>
    </b-row>

      <b-modal v-model="modal" centered size="md" body-class="p-0" :hide-footer="true" :hide-header="true">
          <social-media-form @save="save"/>
      </b-modal>
  </div>
</template>
<script>

    import SwalMixin from "@/views/mixins/Swal.js";
    import SocialMediaForm from './SocialMediaForm.vue';
    import NumberFormatComponent from '@/views/helpers/NumberFormatComponent.vue';
    export default {
        mixins:[SwalMixin],
        components: {NumberFormatComponent,SocialMediaForm},
        props:{
            params: {
                type: Object,
                default: {},
                required: true
            },
        },
        data() {
            return {
                modal:false
            }
        },
        methods:{
            deleteSocialMedia(id){
                this.swalConfirmDelete((data)=>{
                    if (data.value) {
                        this.is_saving=true;
                        this.axios.delete('maintenance/manpowers/social-media/delete',{ data: {id:id} }).then(response => {
                            this.swalTransactionCompleted();
                            this.is_saving=false;
                            this.$emit('save');
                        }).catch(error => {
                            this.swal_transaction_error_data.text = error.response.data;
                            this.swalRequestError();
                            this.is_saving=false;
                        });
                    }
                });
                
            },
            save(){
                this.$emit('save');
                this.modal=false;
            },
        }
    }
</script>
